import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the ambassadorsImport state domain
 */

const selectAmbassadorsImportDomain = (state) =>
  state.get("ambassadorsImport", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsDownloading = () =>
  createSelector(selectAmbassadorsImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectAmbassadorsImportDomain, (state) =>
    state.get("isUploading")
  )
/**
 * Default selector used by AmbassadorsImport
 */

const makeSelectAmbassadorsImport = () =>
  createSelector(selectAmbassadorsImportDomain, (substate) => substate.toJS())

export default makeSelectAmbassadorsImport
export { selectAmbassadorsImportDomain }
